var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 9.75V20.5833H8.66675V9.75H17.3334ZM15.7084 3.25H10.2917L9.20841 4.33333H5.41675V6.5H20.5834V4.33333H16.7917L15.7084 3.25ZM19.5001 7.58333H6.50008V20.5833C6.50008 21.775 7.47508 22.75 8.66675 22.75H17.3334C18.5251 22.75 19.5001 21.775 19.5001 20.5833V7.58333Z",
    fill: "#052425",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.7e21597ee4144d5dab54cd213db01535.svg";
export { ForwardRef as ReactComponent };